import { Button, Flex, FormLabel, Text, Textarea, useClipboard } from "@chakra-ui/react"
import { useEffect, useRef, useState } from "react"
import { useBrandedTranslation } from "../../../common/hooks/useBrandedTranslation"
import { TenderTextType } from "../../../common/types/product"
import MenuFilter from "../MenuFilter"

type Props = {
  title: string
  tenderTexts: TenderTextType[]
  isOutline?: boolean
}

type CopyHandler = (
  event: React.MouseEvent<HTMLButtonElement>,
  ref: React.MutableRefObject<HTMLTextAreaElement>
) => ReturnType<React.MouseEventHandler<HTMLButtonElement>>

const TenderTextArea = ({ title, tenderTexts, isOutline = false }: Props) => {
  const { t } = useBrandedTranslation()
  const [selectedIndex, setSelectedIndex] = useState(0)
  /* Custom Chakra hook for using the system clipboard */
  const { onCopy, setValue } = useClipboard("")
  const textAreaRef = useRef(null)

  /* Define tender text based on the type we pass, it's Array for outline and Object for long */
  const tenderText: TenderTextType = tenderTexts[selectedIndex]

  const textAreaValue = isOutline ? tenderText.detailText : tenderText?.outlineText + "\n\n" + tenderText?.detailText

  useEffect(() => {
    setValue(textAreaValue)
  }, [textAreaValue, setValue])

  const handleCopy: CopyHandler = (
    e: React.MouseEvent<HTMLButtonElement>,
    ref: React.MutableRefObject<HTMLTextAreaElement>
  ) => {
    /* Invoke the actual copy to clipboard operation */
    onCopy()
    /* Select the text in the text area to give visual indication to the user */
    ref.current.select()
  }

  return (
    <Flex flexDirection="column" gap="2">
      <Flex alignItems="center" justifyContent="space-between">
        <FormLabel fontSize="sm" m="0">
          {title}
        </FormLabel>
        <Button aria-label="Copy long text" variant="secondary" px="2" onClick={(e) => handleCopy(e, textAreaRef)}>
          {t("pdp-tenderText-copy")}
        </Button>
      </Flex>
      {isOutline &&
        (tenderTexts?.length > 1 ? (
          <MenuFilter
            menuOptions={tenderTexts.map((tt, i) => ({ name: tt.outlineText, value: `${i}` }))}
            selectedOption={`${selectedIndex}`}
            menuTitle=""
            matchWidth
            handleSelect={(option) => setSelectedIndex(Number(option))}
          />
        ) : (
          <Flex alignItems="center" bgColor="gray.100" width="100%" mb="2" minH={{ base: "11", md: "10" }} px="2">
            <Text as="span" fontSize="sm">
              {tenderText.outlineText}
            </Text>
          </Flex>
        ))}
      <Textarea
        w="100%"
        h="33.5"
        px="2"
        py="3"
        fontSize="xs"
        value={textAreaValue}
        overflow="auto"
        resize="none"
        ref={textAreaRef}
        isReadOnly
        _focusVisible={{}}
      />
    </Flex>
  )
}

export default TenderTextArea
